import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import zh from './zh'
import hk from './hk'
import store from "@/store/index.js";
import router from "@/router"; 
const fullUrl = window.location.href;
if (fullUrl.includes('/en-US')) {
    store.commit("setAttr", {
        name: "language",
        val: 'en',
    })
} else if(fullUrl.includes('/zh-HK')) {
    store.commit("setAttr", {
        name: "language",
        val: 'hk',
    })
} else {
    store.commit("setAttr", {
        name: "language",
        val: 'zh',
    })
}
Vue.use(VueI18n)
const lang = store.state.language || "zh";
const i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'zh',
  silentTranslationWarn: true, // 设置为true 会屏蔽翻译在控制台报出的警告
  messages: { en, zh, hk }
})
// 暴露语言切换方法（带缓存）
i18n.setLocaleAndSave = (route,lang) => {
  if(store.state.language == lang){
    return
  }
  i18n.locale = lang
  store.commit("setAttr", {
    name: "language",
    val: lang,
  })
  localStorage.setItem('inviteLang', lang)
  if(lang == 'en') {
    if (route.fullPath.indexOf('/en-US') == -1) {
      router.push({ path: '/en-US' + route.fullPath.replace('/zh-HK', '') });
    }
  }
  if (lang == 'zh') {
    const newPath = route.fullPath.replace('/en-US', '').replace('/zh-HK', '');
    router.push({ path: newPath == '' ? '/' : newPath });
  }
  if (lang == 'hk') {
    if (route.fullPath.indexOf('/zh-HK') == -1) {
      router.push({ path: '/zh-HK' + route.fullPath.replace('/en-US', '') });
    }
  }
}

export default i18n;
